/**
 * State of the flights filter
 *
 * @export
 * @class State
 */
export class State {
	directFlights: boolean;
	cabinOptions: string;
	baggageIncluded: boolean;
	onlyRefundable: boolean;
	schedule: Array<any>;
	airline: boolean;
	airlines: Array<string>;
	bookAwardFlights: boolean;
	starAlliance: boolean;
	payWithMilesEditableState: boolean;
	live_azores_madeira: boolean;
	student: boolean;
	flightWithMiles: boolean;
}

export const initialState: State = {
	directFlights: false,
	cabinOptions: 'E',
	baggageIncluded: false,
	onlyRefundable: false,
	schedule: null,
	airline: false,
	airlines: [],
	bookAwardFlights: false,
	starAlliance: false,
	live_azores_madeira: false,
	payWithMilesEditableState: true,
	student: false,
	flightWithMiles: false
};

